const EPSILON = 1e-10

function isPointOnSegment([x, y], [startX, startY], [endX, endY]) {
  const crossProduct = (y - startY) * (endX - startX)
    - (x - startX) * (endY - startY)

  if (Math.abs(crossProduct) > EPSILON) return false

  const dotProduct = (x - startX) * (x - endX)
    + (y - startY) * (y - endY)

  return dotProduct <= EPSILON
}

function isPointInsideRing(point, ring) {
  if (!Array.isArray(ring) || ring.length < 3) return false

  const [x, y] = point
  let inside = false

  for (let index = 0, previous = ring.length - 1;
    index < ring.length;
    previous = index, index += 1) {
    const currentPoint = ring[index]
    const previousPoint = ring[previous]

    if (isPointOnSegment(point, currentPoint, previousPoint)) return true

    const [currentX, currentY] = currentPoint
    const [previousX, previousY] = previousPoint
    const crossesHorizontalRay = (currentY > y) !== (previousY > y)
      && x < ((previousX - currentX) * (y - currentY))
        / (previousY - currentY) + currentX

    if (crossesHorizontalRay) inside = !inside
  }

  return inside
}

export default function isPointInsidePolygon(point, polygon) {
  if (!Array.isArray(point) || point.length < 2) return false
  if (!polygon?.coordinates?.length) return false

  const [outerRing, ...holes] = polygon.coordinates

  return isPointInsideRing(point, outerRing)
    && !holes.some((hole) => isPointInsideRing(point, hole))
}
